// extracted by mini-css-extract-plugin
module.exports = {"BlogPostContent":"styles_BlogPostContent__GgDs5","bg_1":"styles_bg_1__q2_oY","height":"styles_height__F0kIS"};